export default {
  data() {
    return {
      isOpenModalAdd: false,
      dataModalAdd: null,
    };
  },

  methods: {
    openModalAdd(data) {
      if (this.isOpenModalAdd) {
        this.toggleModalAdd(false);
        setTimeout(() => {
          if (data) this.dataModalAdd = data;
          this.toggleModalAdd(true);
        }, 200);
      } else {
        if (data) this.dataModalAdd = data;
        this.toggleModalAdd(true);
      }
    },

    toggleModalAdd(isShow) {
      if (isShow) {
        this.isOpenModalAdd = true;
        setTimeout(() => {
          const element = document.getElementById(this.idModalAdd);
          if (element) element.classList.add('show');
        }, 200);
      } else {
        const element = document.getElementById(this.idModalAdd);
        if (element) element.classList.remove('show');

        setTimeout(() => {
          this.isOpenModalAdd = false;
          this.dataModalAdd = null;
        }, 200);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/app-manager/jMixModalAdd.js